import React from "react";
import Image from "next/image";
import dynamic from 'next/dynamic';
const MobileSlider = dynamic(() => import("../Banner/mobile-slider"), { ssr: true });
import { parseHtml, toWebp } from "@/utils/common";

interface CRMSystemProps {
  isMobile: any;
  data?: any;
}

const baseUrl = `${process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL}`;
const CRMSystem: React.FC<CRMSystemProps> = ({ isMobile, data }) => {
  return (
    <div className="bg-background-dark text-white relative">
      <section className="bg-background-white xl:py-25 md:py-[80px] py-[56px] relative">
        <div className="container mx-auto px-4 relative z-10">
          {/* Heading */}
          <h2 className="text-heading-1 font-bold text-center capitalize max-w-[1240px] mx-auto mb-[24px]">
            {data?.title ?? ""}
          </h2>

          <p className="text-subtitle-2 text-white font-regular mt-3 text-center mb-7">
            {data?.short_title ?? ""}
          </p>

          {!isMobile && (
            <>
              {/* Grid */}
              <div className="grid grid-cols-1 gap-[30px] xl:gap-[80px] mt-[40px] md:gap-[56px]">
                {data?.technologies?.map((item: any, index: number) => (
                  <div
                    key={item?.id}
                    className="border border-[#32343B] group relative  overflow-hidden bg-background-dark"
                  >
                    <div
                      className={`h-[440px] grid sm:grid-cols-2 ${index % 2 === 0 ? "sm:[&>*:first-child]:order-2" : ""}`}
                    >
                      {/* Content Section */}
                      <div className="flex flex-col items-start justify-center text-left p-[32px_24px_56px_24px] lg:p-[32px_30px_56px_30px]">
                        <h3 className="text-secondary-text-white xl:text-heading-4 lg:text-[32px] md:text-[24px] font-bold mb-[12px] xl:mb-[24px] max-w-[540px]">
                          {item?.display_title}
                        </h3>
                        <p className="text-secondary-text-white text-subtitle-1">
                          {parseHtml(item?.text ?? "")}
                        </p>
                      </div>

                      {/* Image Section */}
                      {item?.image?.data?.attributes?.url && (
                        <div className="relative overflow-hidden">
                          <Image
                            src={toWebp(
                              `${baseUrl}${item?.image?.data?.attributes?.url}`,
                            )}
                            alt={item?.title}
                            fill
                            className="object-cover transition-transform duration-700 ease-out will-change-transform group-hover:scale-105"
                          />
                        </div>
                      )}
                    </div>

                    {/* Background overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out pointer-events-none" />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {isMobile && (
          <>
            <MobileSlider>
              {data?.technologies?.map((item?: any) => (
                <div
                  key={item?.id}
                  className="border border-[#32343B] group relative card-approch overflow-hidden bg-background-dark"
                >
                  <div
                    className={`overflow-hidden h-full grid sm:grid-cols-2 grid-cols-1 gap-[30px] justify-center `}
                  >
                    {/* Image Section */}
                    {item?.image?.data?.attributes?.url && (
                      <div className="h-[440px] overflow-hidden">
                        <Image
                          src={toWebp(
                            `${baseUrl}${item?.image?.data?.attributes?.url}`,
                          )}
                          alt={item?.title}
                          width={600}
                          height={440}
                          className="w-full h-full object-cover md:min-h-[440px] md:max-h-[440px] 
                        transition-all duration-700 ease-out transform 
                        group-hover:scale-105 group-hover:-translate-y-2"
                        />
                      </div>
                    )}

                    {/* Content Section */}
                    <div className="flex flex-col items-center md:items-start min-h-[440px] max-h-[440px] justify-center text-center md:text-left flex-1 p-[32px_24px_56px_24px] lg:p-[32px_30px_56px_30px] relative">
                      <h3 className="text-secondary-text-white xl:text-heading-5 lg:text-[32px] md:text-[24px] font-bold mb-[12px] xl:mb-[24px] max-w-[540px] transition-colors duration-300">
                        {item?.display_title}
                      </h3>
                      <p className="text-secondary-text-white text-subtitle-1 transition-all duration-500 ease-out delay-150">
                        {parseHtml(item?.text ?? "")}
                      </p>
                    </div>
                  </div>

                  {/* Background overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out pointer-events-none" />
                </div>
              ))}
            </MobileSlider>
          </>
        )}

        {/* Background Images */}
        {!isMobile &&
          <div
            className="
            absolute w-full h-full top-0 left-0 right-0 bottom-0 z-0
            bg-no-repeat bg-cover bg-top
            hidden md:block
          "
            style={{
              backgroundImage: "url('/images/crm/troo-approach.png')",
            }}
          />
        }
        {isMobile &&
          <div
            className="
            absolute w-full h-full top-0 left-0 right-0 bottom-0 z-0
            bg-no-repeat bg-cover bg-top
            block md:hidden
          "
            style={{
              backgroundImage: "url('/images/consulting/bg-approch-mobile.png')",
            }}
          />
        }
      </section>
    </div>
  );
};
export default CRMSystem;
